<div class="max-w-5xl text-center mx-auto px-6">
  <div class="py-20 md:py-32">
    <img
      src="/images/home-art.png"
      class="inline-block h-[400px]"
      alt="AutoRoyale"
    />
    <!-- <h1 class="text-5xl md:text-9xl font-display">AutoRoyale</h1> -->
    <p class="max-w-3xl text-2xl mx-auto mt-10 text-white/80">
      A fast-paced 2D multiplayer shooter. Outwit, outgear, and outlast your
      opponents. It's all about thinking a few steps ahead. Upgrade weapons,
      toss grenades, and pull off sneaky ambushes.
    </p>
  </div>
  <slot />

  <div class="mt-32">
    <h2 class="text-5xl mb-20 font-bold">How to play</h2>

    <div class="space-y-20 mb-40">
      <div class="flex gap-6 md:gap-10 items-center flex-col md:flex-row">
        <div class="flex-1">
          <img src="/images/tutorial/plan.jpg" alt="" class="rounded-xl" />
        </div>
        <div class="flex-1 text-left">
          <h3 class="text-2xl mb-3 font-bold">Plan your moves ahead</h3>
          <p class="text-lg text-white/80">
            Plan ahead and anticipate the movements of your enemies to ensure
            your actions land as intended. Switch to offensive stance when
            you're ready to attack enemies on sight, or switch to defensive
            stance to avoid combat and focus on exploring the environment.
          </p>
        </div>
      </div>

      <div class="flex gap-6 md:gap-10 items-center flex-col md:flex-row">
        <div class="flex-1 text-left order-2 md:order-1">
          <h3 class="text-2xl mb-3 font-bold">Gear up quickly</h3>
          <p class="text-lg text-white/80">
            The map is filled with randomly placed items that will help you
            survive and outplay your opponents. Prioritize finding a weapon as
            soon as you spawn. Also, don't forget to look for utility items. The
            more boots you pick up, the faster you move. Medkits will restore
            your health. Houses often contain a lot of these items, so don't
            hesitate to venture inside!

            <br /><br />

            Collecting more of the same items will upgrade them to a more
            powerful version.
          </p>
        </div>
        <div class="flex-1 order-1 md:order-2">
          <img src="/images/tutorial/items.webp" alt="" class="rounded-xl" />
        </div>
      </div>

      <div class="flex gap-6 md:gap-10 items-center flex-col md:flex-row">
        <div class="flex-1">
          <img src="/images/tutorial/ambush.webp" alt="" class="rounded-xl" />
        </div>
        <div class="flex-1 text-left">
          <h3 class="text-2xl mb-3 font-bold">
            Use the environment to your advantage
          </h3>
          <p class="text-lg text-white/80">
            Stealth is key in this game. Hide in brushes to ambush unsuspecting
            enemies. Remember to adapt your strategy based on the weapon you
            find and your spawn location on the map. Exploit the environment and
            play smart to outmaneuver your opponents.
          </p>
        </div>
      </div>
      <div class="flex gap-6 md:gap-10 items-center flex-col md:flex-row">
        <div class="flex-1 text-left order-2 md:order-1">
          <h3 class="text-2xl mb-3 font-bold">
            Survive the constricting battlefield
          </h3>
          <p class="text-lg text-white/80">
            As the game progresses, the map will start to shrink, Battle Royale
            style. Stay clear of the toxic zone that forms at the map edges.
            Make sure to keep moving towards the center of the map while keeping
            a close eye on your enemies. Your ultimate goal is to be the last
            survivor.
          </p>
        </div>
        <div class="flex-1 order-1 md:order-2">
          <img
            src="/images/tutorial/death-zone.jpg"
            alt=""
            class="rounded-xl"
          />
        </div>
      </div>
    </div>
  </div>
</div>

<div class="text-center text-sm p-2 text-gray-400">
  created by <a href="https://twitter.com/olaszakos" class="hover:text-white"
    >@olaszakos</a
  >
</div>
